// Guardar filtros
export const saveFiltros = (context, bool, item, moduleName = 'tickets') => {
    const filtros_modulo = context.$store.getters.get_filtros[moduleName] || {};

    if (bool) {
        filtros_modulo.filtros = item;
    } else {
        filtros_modulo.page = context.page || 1;
        filtros_modulo.itemsPerPage = context.itemsPerPage || 15;
    }

    context.$store.dispatch("setFiltros", {
        name: moduleName,
        filtros: filtros_modulo,
    });

    context.$emit("update:filtros", filtros_modulo);
}

export const loadFiltros = (context, moduleName = 'tickets') => {
    const filtros_modulo = context.$store.getters.get_filtros[moduleName];

    if (filtros_modulo != null) {
        // Solo actualizamos page e itemsPerPage si existen en el contexto
        if (context.page !== undefined) {
            context.page = filtros_modulo.page || 1;
        }
        if (context.itemsPerPage !== undefined) {
            context.itemsPerPage = filtros_modulo.itemsPerPage || 15;
        }

        return filtros_modulo.filtros || null;
    }
    return null;
}

export const randomUUID = () => {
    return crypto.randomUUID();
}

export const isEmpty = value => {
    if (value === null || value === undefined || value === '')
      return true
    
    return !!(Array.isArray(value) && value.length === 0)
  }